import enLang from "./entries/en_US";
import zhLang from "./entries/zh_CN";
import frLang from "./entries/fr_FR";
import jaLang from "./entries/ja_JP";
import sqLang from "./entries/sq_SQ";
import trLang from "./entries/tr_TR";
import bsLang from "./entries/bs_BS";

const AppLocale = {
    en: enLang,
    zh: zhLang,
    fr: frLang,
    ja: jaLang,
    sq: sqLang,
    tr: trLang,
    bs: bsLang,
};

export default AppLocale;
